export type TimelineType = 'education' | 'experience' | 'certification';

export interface IExperienceLink {
  text: string;
  url: string;
}

export interface IExperience {
  id: string;
  title: string;
  organization: string;
  period: string;
  type: TimelineType;
  description: string;
  achievements: string[];
  link?: IExperienceLink;
}

export class Experience implements IExperience {
  id: string;
  title: string;
  organization: string;
  period: string;
  type: TimelineType;
  description: string;
  achievements: string[];
  link?: IExperienceLink;

  constructor(data: IExperience) {
    this.id = data.id;
    this.title = data.title;
    this.organization = data.organization;
    this.period = data.period;
    this.type = data.type;
    this.description = data.description;
    this.achievements = data.achievements;
    this.link = data.link;
  }

  public getTypeBadge(): string {
    switch (this.type) {
      case 'education': return 'B.S. Degree';
      case 'experience': return 'Work / Internship';
      case 'certification': return 'Certification';
      default: return 'Milestone';
    }
  }
}
